
import React, {useState} from "react";
import Button from "components/button/button"
import LoadingIndicator from "assets/svg/loading-indicator";
import { FaCheck, FaLink } from "react-icons/fa6";
import { FaCheckCircle } from "react-icons/fa";
import {  useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

let noop = ()=>{};
const SaveFilters = (
    {
    saveFilterSearch = noop(),
    isLoading = false,
    getFormattedLocalTime = noop,
    savedFilter=false
  }
)=>{ 
    const {t} = useTranslation()
    const history = useHistory();
    
    return(
        <div className={`flex w-full border  rounded-md items-center justify-center mt-2
          ${savedFilter ? 'border-[#2bae78] bg-[#e4fbee]' : 'border-gray bg-white'}
        `}>
          <div className="h-14 flex items-center justify-center gap-2">
            <div className="flex items-center justify-center font-semibold text-xs 5sm:text-sm gap-1">
              { savedFilter ?
                <>
                  <FaCheckCircle className="text-[#2bae78] text-lg"/>
                  <span className="font-bold">{t('succSaveNewPubView')}</span>
                  <span className="text-primary font-semibold underline cursor-pointer"
                    onClick={()=>{
                      const url = new URL(window.location.href);
                      url.searchParams.set('viewPublic', 'true');
                      history.push(url.pathname + url.search,
                        {
                          viewPublicFilter: true,
                          viewPublic: true
                        }
                      );
                    }}
                  >{t('seePublicView')}</span>
                </>
                :
                <>
                  {t('savePublic')}
                  { !isLoading &&
                    <FaCheck className="text-primary w-4 h-4"/>
                  }
                  <span className="text-primary cursor-pointer" > 
                  <Button onClick={()=>{saveFilterSearch()}} disabled={isLoading}
                    buttonName={t('saveView')}
                    buttonClass="relative bg-white text-primary underline"
                    buttonTextClass="text-primary text-sm font-semibold flex items-center font-semibold"
                    // iconPosition={`${isLoading ? 'right':'left'}`}
                    loadingIcon={
                      isLoading ? (
                          <LoadingIndicator className="text-primary w-4 h-4 ml-2" />
                      ) : null
                      }
                    >{t('saveView')}</Button>
                  </span>

                  { !isLoading &&
                    <FaLink className="text-primary w-4 h-4 ml-2"/>
                  }
                  <span className="text-primary cursor-pointer" > 
                  <Button onClick={()=>{saveFilterSearch(true)}} disabled={isLoading}
                    buttonName="Share Link"
                    buttonClass="relative bg-white text-primary underline"
                    buttonTextClass="text-primary text-sm font-semibold flex items-center font-semibold"
                    // iconPosition={`${isLoading ? 'right':'left'}`}
                    loadingIcon={
                      isLoading ? (
                          <LoadingIndicator className="text-primary w-4 h-4 ml-2" />
                      ) : null
                      }
                    >Share Link</Button>
                  </span>
                </>
              }
              
            </div>
            {
              savedFilter && 
              <>
                <div className="h-3 w-px bg-gray-400"></div>
                <div className="text-gray-400 text-2xs 5sm:text-xs">
                  {getFormattedLocalTime()}
                </div>
              </>
            }
          </div>
        </div>
    )
}

export default SaveFilters;